/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StorageLocationVo
 */
export interface StorageLocationVo {
    /**
     * 货位号
     * @type {string}
     * @memberof StorageLocationVo
     */
    locationNo?: string;
    /**
     * 箱号/唛头号
     * @type {string}
     * @memberof StorageLocationVo
     */
    boxNo?: string;
    /**
     * 是否单独保管：0 否 1 是
     * @type {number}
     * @memberof StorageLocationVo
     */
    separateStore?: number;
    /**
     * 数量
     * @type {number}
     * @memberof StorageLocationVo
     */
    quantity?: number;
}

/**
 * Check if a given object implements the StorageLocationVo interface.
 */
export function instanceOfStorageLocationVo(value: object): value is StorageLocationVo {
    return true;
}

export function StorageLocationVoFromJSON(json: any): StorageLocationVo {
    return StorageLocationVoFromJSONTyped(json, false);
}

export function StorageLocationVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageLocationVo {
    if (json == null) {
        return json;
    }
    return {
        
        'locationNo': json['locationNo'] == null ? undefined : json['locationNo'],
        'boxNo': json['boxNo'] == null ? undefined : json['boxNo'],
        'separateStore': json['separateStore'] == null ? undefined : json['separateStore'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
    };
}

export function StorageLocationVoToJSON(json: any): StorageLocationVo {
    return StorageLocationVoToJSONTyped(json, false);
}

export function StorageLocationVoToJSONTyped(value?: StorageLocationVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationNo': value['locationNo'],
        'boxNo': value['boxNo'],
        'separateStore': value['separateStore'],
        'quantity': value['quantity'],
    };
}

